import Highlight from "./Highlight";
export default Highlight;


// WEBPACK FOOTER //
// ./src/Highlight/index.js